import { BasicOperatorType } from "@app/exports/enumerations";
import { LocationConfidenceScoreLabelEnum, ProviderNetworkType } from "@app/projects/enumerators";
import { DropdownItem } from "@app/shared/checkbox-dropdown";
import { wafflesKeyColumnName } from "@app/shared/waffles/exports";
import { JSX } from "react";

export interface RegionSetSpecialtyGroupsWithGaps {
  regionSetSpecialtyGroupId: number;
  serviceArea: string;
  specialtyGroup: string;
  servicingProviderIdsThatCloseGaps?: number[]
}

export interface RegionSetSpecialtyGroupsWithGapsTableData {
  [wafflesKeyColumnName]: string;
  serviceArea: string;
  specialtyGroup: string;
  providersImpactCount: JSX.Element
}

export interface ProviderHubCountiesImpacted {
  key: string,
  countyName: string,
  stateCode: string
}

export interface ProviderHubSpecialtiesImpacted {
  key: string,
  name: string
}

export interface ProviderHubServicingProviders {
  servicingProviderId: number
  providerName: string;
  npi: string;
  networkTypes: ProviderNetworkType[],
  gapsClosed: number,
  specialtiesImpacted: ProviderHubSpecialtiesImpacted[],
  countiesImpacted: ProviderHubCountiesImpacted[],
  accessPointCount: number,
  primaryContractEntity: string,
  contractEntityProviders: number
}

export interface ProviderHubServicingProvidersTableData {
  [wafflesKeyColumnName]: string;
  providerName?: string;
  npi?: string;
  networkTypes: JSX.Element,
  gapsClosed: string,
  specialtiesImpacted: JSX.Element | string,
  countiesImpacted: JSX.Element | string,
  accessPoints: JSX.Element | string,
  primaryContractEntity?: string,
  contractEntityProviders?: number,
  locationConfidence?: string
}

export interface ServicingProviderAccessPoints {
  accessPointId: number,
  networkType: ProviderNetworkType,
  gapsClosed: number,
  specialtyImpacted: string,
  countiesImpacted: ProviderHubCountiesImpacted[],
  address: string,
  address2?: string,
  state: string,
  city: string,
  zip: string,
  locationConfidence?: LocationConfidenceScoreLabelEnum
}

export interface HighlightedRegionSetSpecialtyGroupsWithGapsAndCount {
  regionSetSpecialtyGroupId: number,
  count? : number
}

export type ProviderHubFilterValueType = | string | number | string[] | DropdownItem<string>[];

export type ProviderHubFilterValue = {
  operator?: BasicOperatorType;
  value: ProviderHubFilterValueType
};

export type ProviderHubFilterState = {
  [columnKey: string]: ProviderHubFilterValue
};

export interface AiChatMessage {
    content: string[];
    messageType: AiChatMessageType;
    timestamp: Date;
    threadId: string;
}

export enum AiChatMessageType {
    Unknown = "unknown",
    UserPrompt = "userPrompt",
    AnalystResponseText = "analystResponseText",
    AnalystResponseSuggestion = "analystResponseSuggestion",
    AnalystResponseSql = "analystResponseSql",
    ResponseText = "responseText",
}
